export default __webpack_public_path__ + "static/media/courier-webfont.3db87073.woff";